module.exports = __webpack_public_path__ + "static/media/spray-decorating.f79d0fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/optimised/spray-decorating.jpg
// module id = 83
// module chunks = 0